
import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import "../../components/style.css";
import up from '../../assets/images/uploading.gif'
// import Sidebar from "../../components/Sidebar";

function Importexport() {
  const [excelData, setExcelData] = useState([]);
  const [saveMessage, setSaveMessage] = useState("");
  const [databaseData, setDatabaseData] = useState([]);
  const [udiseNumber, setUdiseNumber] = useState('');
  const [upshowing, setUpshowing] = useState(false);

  const [packActivated, setPackActivated] = useState('');


  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "English"
  );

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language") || "English";
    setLanguage(storedLanguage);
  }, []);
  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);

  const [showDataTable, setShowDataTable] = useState(false);


  const [dynamicStudentLimit, setDynamicStudentLimit] = useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        if (udiseNumber) {
          const response = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${udiseNumber}.json`
          );
          
          if (response.ok) {
            const data = await response.json();
            if (data) {
              setPackActivated(data.packActivated || '');
              if (data.studentLimit) {
                let limit = data.studentLimit;
                if (typeof limit === "string") {
                  const matches = limit.match(/\d+/);
                  if (matches) {
                    limit = parseInt(matches[0], 10);
                  } else if (limit.toLowerCase().includes("unlimited")) {
                    limit = Infinity;
                  } else {
                    limit = parseInt(limit, 10);
                  }
                }
                if (!isNaN(limit)) {
                  setDynamicStudentLimit(limit);
                }
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching admin data:", error);
      }
    };
    
    fetchAdminData();
  }, [udiseNumber]);

  const toggleDataTableVisibility = () => {
    setShowDataTable(!showDataTable); // Toggle the visibility state
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0'); 
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear(); 
    return `${day}-${month}-${year}`;
  };


  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = async (evt) => {
      const data = evt.target.result;
      const workbook = XLSX.read(data, { type: "binary", cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
  
      // Get the range of the sheet
      const range = XLSX.utils.decode_range(sheet["!ref"]);
  
      // Start reading from the second row (skip header)
      range.s.r = 1;
      sheet["!ref"] = XLSX.utils.encode_range(range);
  
      // Convert sheet to JSON with empty cells preserved
      const jsonData = XLSX.utils.sheet_to_json(sheet, {
        header: 1, // Use array of arrays (rows) instead of objects
        defval: "", // Set default value for empty cells to an empty string
        raw: false, // Ensure raw values are not used
      });
  
      // Map the JSON data to ensure each row has the correct number of columns
      const formattedData = jsonData.map((row) => {
        // Ensure the row has the same number of columns as the header
        const paddedRow = new Array(columns.length).fill(""); // Fill with empty strings
        row.forEach((cell, index) => {
          if (index < paddedRow.length) {
            paddedRow[index] = cell === undefined ? "" : cell; // Copy cell value to the correct position
          }
        });
  
        // Format specific fields (e.g., Aadhar number, DOB)
        const aadharIndex = columns.findIndex(
          (col) => col === "Student Adhar No" || col === "विद्यार्थी आधार क्र"
        );
        if (aadharIndex !== -1 && paddedRow[aadharIndex]) {
          let aadharNumber = paddedRow[aadharIndex].trim();
          if (aadharNumber.length !== 12 || !/^\d+$/.test(aadharNumber)) {
            console.error("Invalid Aadhar number detected:", aadharNumber);
            aadharNumber = ""; // Set to empty string if invalid
          }
          paddedRow[aadharIndex] = `${aadharNumber}`; // Prefix with apostrophe to treat as text
        }
        const dobIndex = columns.findIndex(
          (col) => col === "Date Of Birth" || col === "जन्मतारीख"
        );
        if (dobIndex !== -1 && paddedRow[dobIndex]) {
          paddedRow[dobIndex] = formatDateString(paddedRow[dobIndex]);
        }
  
        const doaIndex = columns.findIndex(
          (col) => col === "Date Of Admission" || col === "प्रवेशाची तारीख"
        );
        if (doaIndex !== -1 && paddedRow[doaIndex]) {
          paddedRow[doaIndex] = formatDateString(paddedRow[doaIndex]);
        }
  
        return paddedRow;
      });
      const nonBlankRows = formattedData.filter(row => row.some(cell => cell !== ""));

      setExcelData(nonBlankRows);
      setSaveMessage(`${nonBlankRows.length} records found`);
    };
  
    reader.readAsBinaryString(file);
  };




  const formatDateString = (dateValue) => {
    if (dateValue === undefined || dateValue === null || dateValue === "") return "";

    // If it's already a Date object (from XLSX with cellDates: true)
    if (dateValue instanceof Date) {
      const year = dateValue.getFullYear();
      const month = String(dateValue.getMonth() + 1).padStart(2, '0');
      const day = String(dateValue.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    const dateString = String(dateValue).trim();
    
    // Check if it's already in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;

    const dateParts = dateString.split(/[-/]/);
    if (dateParts.length === 3) {
      let day, month, year;

      // Detect YYYY-MM-DD or YYYY-DD-MM
      if (dateParts[0].length === 4) {
        [year, month, day] = dateParts;
      } 
      // Detect DD-MM-YYYY or MM-DD-YYYY or 2-digit years
      else {
        [day, month, year] = dateParts;
        
        // Fix 2-digit year (e.g., '24' -> '2024')
        if (year.length === 2) {
          const y = parseInt(year);
          year = y > 50 ? "19" + year : "20" + year;
        }

        // Smart swap if month > 12 (likely MM-DD-YYYY format)
        if (parseInt(month) > 12 && parseInt(day) <= 12) {
          [day, month] = [month, day];
        }
      }

      day = String(day).padStart(2, '0');
      month = String(month).padStart(2, '0');
      year = String(year).padStart(4, '0');

      return `${year}-${month}-${day}`;
    }

    // Try parsing as a serial date if it's a number (Excel serial date)
    if (!isNaN(dateString) && dateString.length > 3) {
        try {
            const serial = parseFloat(dateString);
            const date = XLSX.SSF.parse_date_code(serial);
            if (date) {
                const y = String(date.y).padStart(4, '0');
                const m = String(date.m).padStart(2, '0');
                const d = String(date.d).padStart(2, '0');
                return `${y}-${m}-${d}`;
            }
        } catch (e) {
            console.error("Error parsing serial date:", e);
        }
    }

    console.warn(`Invalid date format: ${dateString}`);
    return ""; 
  };


  const columns = [
    language === "English" ? "Admission Class" : "प्रवेश वर्ग",
    language === "English" ? "Register No" : "नोंदणी क्र",
    language === "English" ? "APAAR Id" : "अपार आयडी",
    language === "English" ? "PEN No" : "PEN क्र",
    language === "English" ? "Student SARAL Id" : "विद्यार्थी सरल आयडी",
    language === "English" ? "Book No" : "पुस्तक क्र",
    language === "English" ? "Birth Place" : "जन्मस्थान",
    language === "English" ? "Caste" : "जात",
    language === "English" ? "Sub Caste" : "पोटजात",
    language === "English" ? "Category" : "श्रेणी",
    language === "English" ? "Religion" : "धर्म",
    language === "English" ? "Country" : "देश",
    language === "English" ? "State" : "राज्य",
    language === "English" ? "Current Class" : "सध्याचा वर्ग",
    language === "English" ? "Division" : "तुकडी",
    language === "English" ? "Date Of Admission" : "प्रवेशाची तारीख",
    language === "English" ? "District" : "जिल्हा",
    language === "English" ? "Taluka" : "तालुका",
    language === "English" ? "Address" : "पत्ता",
    language === "English" ? "Pincode" : "पिनकोड",
    language === "English" ? "Date Of Birth" : "जन्मतारीख",
    language === "English" ? "DOB In Words" : "शब्दात जन्मतारीख",
    language === "English" ? "Educational Year" : "शैक्षणिक वर्ष",
    language === "English" ? "Gender" : "लिंग",
    language === "English" ? "Is Minority" : "अल्पसंख्याक",
    language === "English" ? "Mobile No" : "मोबाईल क्र.",
    language === "English" ? "Student Adhar No" : "विद्यार्थी आधार क्र",
    language === "English" ? "Mother Tongue" : "मातृभाषा",
    language === "English" ? "Nationality" : "राष्ट्रीयत्व",
    language === "English" ? "Previous School" : "मागील शाळा",
    language === "English" ? "Previous Class" : "मागील इयत्ता",
    language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव",
    language === "English" ? "Father Name" : "वडीलांचे नावं",
    language === "English" ? "Mother Name" : "आईचे नाव",
    language === "English" ? "Student Surname" : "विद्यार्थ्याचे आडनाव",
    language === "English" ? "Blood Group" : "रक्त गट",
    language === "English" ? "Father's Occupation" : "वडिलांचा व्यवसाय",
    language === "English" ? "Mother's Occupation" : "आईचा व्यवसाय",
    language === "English" ? "Father's Phone Number" : "वडिलांचा फोन नंबर",
    language === "English" ? "Mother's Phone Number" : "आईचा फोन नंबर",
    language === "English" ? "Boarder/Resident Student?" : "बोर्डर/निवासी विद्यार्थी?",
    language === "English" ? "Is the student a Scholar?" : "विद्यार्थ्याला शिष्यवृत्ती आहे का?",
    language === "English" ? "Scholarship Name" : "शिष्यवृत्तीचे नाव",
    language === "English" ? "ELGA" : "ELGA",
    language === "English" ? "RTE?" : "RTE?",
    'Active Status'

  ];
  const useTemplate = () => {
    const wb = XLSX.utils.book_new(); // Create a new workbook
    const ws = XLSX.utils.aoa_to_sheet([columns]); // Create a new worksheet with headers
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); // Add the worksheet to the workbook
    XLSX.writeFile(wb, "template.xlsx"); // Download the workbook as 'template.xlsx'
  };
// Define a mapping object for column headings to database field names
const headingToFieldName = {
  "Admission Class": "admissionClass",
  "Register No": "registerNo",
  "APAAR Id": "aparId",
  "PEN No": "panId",
  'Student SARAL Id': 'studentId',
  "Book No": 'bookno',
"Birth Place" : 'birthPlace',
"Caste" : 'caste',
'Sub Caste': 'subCaste',
"Category" : 'category',
"Religion": 'religion',
"Country" : 'country',
"State" : 'state',
"Current Class"  : 'currentClass',
"Division" : 'division',
"Date Of Admission" : 'dateOfAdmission',
"District" : 'district',
"Taluka"  : 'taluka',
"Address"  : 'address',
"Pincode"  : 'pincode',
"Date Of Birth" : 'dob',
"DOB In Words": 'dobInWords',
"Educational Year": 'educationalYear',
"Gender" : 'gender',
"Is Minority" : 'isMinority',
"Mobile No" : 'mobileNo',
"Student Adhar No" : 'stdAdharNo',
"Mother Tongue" : 'motherTounge',
"Nationality" : 'nationality',
"Previous School" : 'prevSchool',
"Previous Class" : 'prevClass',
"Student Name" : 'stdName',
"Father Name" : 'stdFather',
"Mother Name" :'stdMother',
"Student Surname" :'stdSurname',
"Blood Group" :'bloodGroup',
"Father's Occupation" :'fOccupation',
"Mother's Occupation" :'mOccupation',
"Father's Phone Number" :'fMobile',
"Mother's Phone Number" :'mMobile',
"Boarder/Resident Student?" :'isHosteller',
"Is the student a Scholar?":'isScolar',
"Scholarship Name":'scolarName',


"प्रवेश वर्ग" : 'admissionClass',
'नोंदणी क्र': 'registerNo',
'अपार आयडी': 'aparId',
'PEN क्र': 'panId',
'विद्यार्थी सरल आयडी': 'studentId',
"पुस्तक क्र" : 'bookno',
"जन्मस्थान" : 'birthPlace',
'जात': 'caste',
'पोटजात': 'subCaste',
'श्रेणी': 'category',
'धर्म': 'religion',
'देश': 'country',
'राज्य': 'state',
'सध्याचा वर्ग': 'currentClass',
'तुकडी': 'division',
'प्रवेशाची तारीख': 'dateOfAdmission',
'जिल्हा': 'district',
'तालुका': 'taluka',
'पत्ता':'address',
'पिनकोड':'pincode',
'जन्मतारीख': 'dob',
'शब्दात जन्मतारीख': 'dobInWords',
'शैक्षणिक वर्ष': 'educationalYear',
'लिंग': 'gender',
'अल्पसंख्याक': 'isMinority',
'मोबाईल क्र.': 'mobileNo',
'विद्यार्थी आधार क्र': 'stdAdharNo',
'मातृभाषा': 'motherTounge',
'राष्ट्रीयत्व': 'nationality',
'मागील शाळा': 'prevSchool',
'मागील इयत्ता': 'prevClass',
'विद्यार्थ्याचे नाव': 'stdName',
'वडीलांचे नावं': 'stdFather',
'आईचे नाव': 'stdMother',
'विद्यार्थ्याचे आडनाव': 'stdSurname',
"रक्त गट" :'bloodGroup',
"वडिलांचा व्यवसाय" :'fOccupation',
"आईचा व्यवसाय" :'mOccupation',
"वडिलांचा फोन नंबर" :'fMobile',
"आईचा फोन नंबर" :'mMobile',
"बोर्डर/निवासी विद्यार्थी?" :'isHosteller',
"विद्यार्थ्याला शिष्यवृत्ती आहे का?":'isScolar',
"शिष्यवृत्तीचे नाव":'scolarName',
"ELGA":'ELGA',
"RTE?":'isRTE',
'Active Status' : 'isActive',
};

const saveDataToFirebase = async () => {
  try {
    setUpshowing(true);
    if (!excelData.length) {
      throw new Error("No data available to save.");
    }

    // Define plan limits
    const planLimits = {
      freeTrial: 10,
      silver: 100,
      gold: 500,
      platinum: 1000,
      "platinum Plus": 2000,
      "platinumPlus": 2000,
      "purchase": Infinity,
    };

    const limit = dynamicStudentLimit !== null
      ? dynamicStudentLimit
      : (planLimits[packActivated] !== undefined
          ? planLimits[packActivated]
          : (planLimits[packActivated?.toLowerCase()] !== undefined ? planLimits[packActivated?.toLowerCase()] : Infinity));

    // Fetch lastAddedSerialNo from Firebase
    let lastAddedSerialNo = 0; // Initialize with default value
    if (udiseNumber) {
      const lastAddedSerialNoResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`
      );
      
      if (lastAddedSerialNoResponse.ok) {
        const value = await lastAddedSerialNoResponse.json();
        lastAddedSerialNo = value || 0; // Use fetched value or default to 0
      }
    }

    // Check if user is on a limited plan and enforce limits
    let dataToSave = excelData;
    let limitMessage = "";
    
    if (limit !== Infinity) {
      
      if (lastAddedSerialNo >= limit) {
        // User has already reached their plan limit
        setSaveMessage(
          language === "English"
            ? `${packActivated === "freeTrial" ? "Free Trial" : packActivated} users can only import up to ${limit} records. You've reached your limit. Upgrade to import more.`
            : `${packActivated === "freeTrial" ? "फ्री ट्रायल" : packActivated} वापरकर्ते फक्त ${limit} पर्यंत रेकॉर्ड आयात करू शकतात. आपण आपली मर्यादा गाठली आहे. अधिक आयात करण्यासाठी अपग्रेड करा.`
        );
        setUpshowing(false);
        return; // Exit the function early
      } 
      else if (lastAddedSerialNo + excelData.length > limit) {
        // User will exceed limit with this import
        const remainingSlots = limit - lastAddedSerialNo;
        if (remainingSlots <= 0) {
          setSaveMessage(
            language === "English"
              ? `${packActivated === "freeTrial" ? "Free Trial" : packActivated} users can only import up to ${limit} records. You've reached your limit. Upgrade to import more.`
              : `${packActivated === "freeTrial" ? "फ्री ट्रायल" : packActivated} वापरकर्ते फक्त ${limit} पर्यंत रेकॉर्ड आयात करू शकतात. आपण आपली मर्यादा गाठली आहे. अधिक आयात करण्यासाठी अपग्रेड करा.`
          );
          setUpshowing(false);
          return; // Exit the function early
        }
        
        // Limit the data to only what fits within the remaining slots
        dataToSave = excelData.slice(0, remainingSlots);
        setSaveMessage(
          language === "English"
            ? `${packActivated === "freeTrial" ? "Free Trial" : packActivated} users can only import ${limit} records. Only ${remainingSlots} records will be imported. Upgrade to import more.`
            : `${packActivated === "freeTrial" ? "फ्री ट्रायल" : packActivated} वापरकर्ते फक्त ${limit} रेकॉर्ड आयात करू शकतात. फक्त ${remainingSlots} रेकॉर्ड आयात केले जातील. अधिक आयात करण्यासाठी अपग्रेड करा.`
        );
      }
    }

    const db = await openIndexedDB();
    const transaction = db.transaction(['studentData'], 'readonly');
    const objectStore = transaction.objectStore('studentData');
    const existingDataRequest = objectStore.getAll();

    existingDataRequest.onsuccess = async (event) => {
      const dbTransaction = db.transaction(['studentData'], 'readwrite');
      const dbObjectStore = dbTransaction.objectStore('studentData');

      const newData = {}; 

      dataToSave.forEach((row, index) => {
        const serialNo = lastAddedSerialNo + index + 1; 
        const formattedRow = {};
    
        columns.forEach((heading, columnIndex) => {
          const fieldName = headingToFieldName[heading];
          if (fieldName) {
            if (fieldName === 'currentClass' || fieldName === 'admissionClass' || fieldName === 'division') {
              const value = row[columnIndex]?.trim() || ""; 
              if (value) { 
              formattedRow[fieldName] = row[columnIndex]
                  ? row[columnIndex].trim().replace(/\s+/g, ' ') 
                  : "";
              }
            } else if (fieldName === 'isMinority') {
              const value = row[columnIndex].trim().toLowerCase();
              if (value) { 
              if (value === 'आहे' || value === 'yes' || value === 'yes') {
                formattedRow[fieldName] = true;
              } else if (value === 'नाही' || value === 'no' || value === 'no' || "") {
                formattedRow[fieldName] = false;
              } else {
                console.warn(`Unexpected value for 'isMinority': ${value}`);
                formattedRow[fieldName] = false;
              }
            }
            } else if (fieldName === 'isHosteller') {
              const value = row[columnIndex].trim().toLowerCase();
              if (value) { 
              if (value === 'yes' || value === 'Yes' || value === 'होय') {
                formattedRow[fieldName] = "true";
              } else if (value === 'no' || value === 'No' || value === 'नाही' || "") {
                formattedRow[fieldName] = "false";
              } else {
                console.warn(`Unexpected value for 'isHosteller': ${value}`);
                formattedRow[fieldName] = "false"; 
              }
            }
            } else if (fieldName === 'isRTE') {
              const value = row[columnIndex].trim().toLowerCase();
              if (value) { 
              if (value === 'yes' || value === 'Yes' || value === 'होय') {
                formattedRow[fieldName] = "true";
              } else if (value === 'no' || value === 'No' || value === 'नाही' || "") {
                formattedRow[fieldName] = "false";
              } else {
                console.warn(`Unexpected value for 'isRTE': ${value}`);
                formattedRow[fieldName] = "false";
              }
            }
            } else if (fieldName === 'isScolar') {
              const value = row[columnIndex].trim().toLowerCase();
              if (value) { 
              if (value === 'yes' || value === 'Yes' || value === 'होय') {
                formattedRow[fieldName] = "true";
              } else if (value === 'no' || value === 'No' || value === 'नाही' || "") {
                formattedRow[fieldName] = "false";
              } else {
                console.warn(`Unexpected value for 'isScolar': ${value}`);
                formattedRow[fieldName] = "false"; 
              }
            }
          } else if (fieldName === 'gender') {
            const value = row[columnIndex].trim().toLowerCase();
            if (value) { 
            if (value === 'मुलगा' || value === 'm' || value === 'male') {
              formattedRow[fieldName] = "male";
            } else if (value === 'मुलगी' || value === 'f' || value === 'female') {
              formattedRow[fieldName] = "female";
            } else {
              console.warn(`Unexpected value for 'gender': ${value}`);
              formattedRow[fieldName] = ""; 
            }
          }  
        }
       else if (fieldName === 'isActive') {
        const value = row[columnIndex].trim().toLowerCase();
        if (value === 'active' || value === 'yes') {
          formattedRow[fieldName] = true; // Save as true
        } else if (value === 'deactive' || value === 'inactive'|| value === 'no') {
          formattedRow[fieldName] = false; // Save as false
        } else {
          console.warn(`Unexpected value for 'isActive': ${value}`);
          formattedRow[fieldName] = false; // Default to false if the value is unexpected
        }
      }
             else {
                const value = row[columnIndex]?.trim() || "";
                if (value) { // Only save fields with values
                  formattedRow[fieldName] = value;
                }
            }
          }
        });

        const key = `${formattedRow.currentClass}-${formattedRow.division || ''}-${serialNo}`;
        dbObjectStore.put({ ...formattedRow, serialNo, id: key }); 

        newData[serialNo] = { ...formattedRow, serialNo }; 
      });

      if (Object.keys(newData).length > 0) {
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newData),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to store data in the database");
        }

        // Only update the lastAddedSerialNo if we actually added data
        const updateSerialNoResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(lastAddedSerialNo + dataToSave.length),
          }
        );

        if (!updateSerialNoResponse.ok) {
          throw new Error("Failed to update lastAddedSerialNo");
        }

        setDatabaseData(Object.values(newData));
      }
      
      setExcelData([]);
      setUpshowing(false);
      
      if (limit === Infinity || (lastAddedSerialNo + dataToSave.length <= limit)) {
        setSaveMessage(
          language === "English"
            ? "Data Saved Successfully"
            : "डेटा यशस्वीरित्या सेव्ह झाला"
        );
      }
    };

    const classDivUpdates = {};
    dataToSave.forEach((row) => {
      const currentClass = row[columns.findIndex(col => col === (language === "English" ? "Current Class" : "सध्याचा वर्ग"))].trim();
      const division = row[columns.findIndex(col => col === (language === "English" ? "Division" : "तुकडी"))].trim(); 
    
      if (currentClass) {
        if (!classDivUpdates[currentClass]) {
          classDivUpdates[currentClass] = {}; 
        }
    
        if (division) {
          classDivUpdates[currentClass][division] = true; 
        }
      }
    });
    
    for (const className in classDivUpdates) {
      if (Object.keys(classDivUpdates[className]).length === 0) {
        classDivUpdates[className] = true; 
      }
    }
    
    const existingClassDiv = JSON.parse(localStorage.getItem("classDiv")) || {};
    for (const [className, divisions] of Object.entries(classDivUpdates)) {
      if (!existingClassDiv[className]) {
        existingClassDiv[className] = {}; 
      }
      if (typeof divisions === 'object' && !Array.isArray(divisions)) {
        Object.assign(existingClassDiv[className], divisions);
      }
    }

    localStorage.setItem("classDiv", JSON.stringify(existingClassDiv));

    existingDataRequest.onerror = (event) => {
      console.error("Error fetching existing data from IndexedDB:", event.target.error);
      setUpshowing(false);
    };
  } catch (error) {
    console.error("Error saving data to Firebase:", error);
    setUpshowing(false); 
  }
};


  const customColumnNames = [
    language === "English" ? "Admission Class" : "प्रवेश वर्ग",
    language === "English" ? "Register No" : "नोंदणी क्र",
    language === "English" ? "APAAR Id" : "अपार आयडी",
    language === "English" ? "PEN No" : "PEN क्र",
    language === "English" ? "Student SARAL Id" : "विद्यार्थी सरल आयडी",
    language === "English" ? "Book No" : "पुस्तक क्र",
    language === "English" ? "Birth Place" : "जन्मस्थान",
    language === "English" ? "Caste" : "जात",
    language === "English" ? "Sub Caste" : "पोटजात",
    language === "English" ? "Category" : "श्रेणी",
    language === "English" ? "Religion" : "धर्म",
    language === "English" ? "Country" : "देश",
    language === "English" ? "State" : "राज्य",
    language === "English" ? "Current Class" : "सध्याचा वर्ग",
    language === "English" ? "Division" : "तुकडी",
    language === "English" ? "Date Of Admission" : "प्रवेशाची तारीख",
    language === "English" ? "District" : "जिल्हा",
    language === "English" ? "Taluka" : "तालुका",
    language === "English" ? "Address" : "पत्ता",
    language === "English" ? "Pincode" : "पिनकोड",
    language === "English" ? "Date Of Birth" : "जन्मतारीख",
    language === "English" ? "DOB In Words" : "शब्दात जन्मतारीख",
    language === "English" ? "Educational Year" : "शैक्षणिक वर्ष",
    language === "English" ? "Gender" : "लिंग",
    language === "English" ? "Is Minority" : "अल्पसंख्याक",
    language === "English" ? "Mobile No" : "मोबाईल क्र.",
    language === "English" ? "Student Adhar No" : "विद्यार्थी आधार क्र",
    language === "English" ? "Mother Tongue" : "मातृभाषा",
    language === "English" ? "Nationality" : "राष्ट्रीयत्व",
    language === "English" ? "Previous School" : "मागील शाळा",
    language === "English" ? "Previous Class" : "मागील इयत्ता",
    language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव",
    language === "English" ? "Father Name" : "वडीलांचे नावं",
    language === "English" ? "Mother Name" : "आईचे नाव",
    language === "English" ? "Student Surname" : "विद्यार्थ्याचे आडनाव",
    language === "English" ? "Blood Group" : "रक्त गट",
    language === "English" ? "Father's Occupation" : "वडिलांचा व्यवसाय",
    language === "English" ? "Mother's Occupation" : "आईचा व्यवसाय",
    language === "English" ? "Father's Phone Number" : "वडिलांचा फोन नंबर",
    language === "English" ? "Mother's Phone Number" : "आईचा फोन नंबर",
    language === "English" ? "Boarder/Resident Student?" : "बोर्डर/निवासी विद्यार्थी?",
    language === "English" ? "Is the student a Scholar?" : "विद्यार्थ्याला शिष्यवृत्ती आहे का?",
    language === "English" ? "Scholarship Name" : "शिष्यवृत्तीचे नाव",
    language === "English" ? "ELGA" : "ELGA",
    language === "English" ? "RTE?" : "RTE?",
    'Active Status',
  ];
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };
  useEffect(() => {
    fetchDataFromDatabase();
  }, [udiseNumber]);

  const fetchDataFromDatabase = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const request = objectStore.getAll(); // Fetch all records
  
      request.onsuccess = (event) => {
        const data = event.target.result;
      if (data) {
        // Convert the object of objects into an array of objects
        const dataArray = Object.keys(data)
          .map((key) => {
            const student = data[key];
            // Check if student is not null
            if (student) {
              // Convert dateOfAdmission from 'yyyy-mm-dd' to 'dd-mm-yyyy'
              if (student.dateOfAdmission) {
                const dateParts = student.dateOfAdmission.split("-");
                if (dateParts.length === 3) {
                  student.dateOfAdmission = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; 
                }
              }
              if (student.dob) {
                  student.dob = formatDate(student.dob)
              
              }
              return student; 
            }
            return null;
          })
          .filter((item) => item !== null); 
        setDatabaseData(dataArray);
      }
    };
    request.onerror = (event) => {
      console.error("Error fetching data from IndexedDB:", event.target.error);
    };
  }catch (error) {
      console.error("Error fetching data from Firebase:", error);
    }
  };
  
  const exportReportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]); 
    const dataRows = databaseData.map((student) => {
      return customColumnNames.map((columnName) => {
        const fieldName = headingToFieldName[columnName];
        if (fieldName === 'isMinority') {
          // Handle the "Is Minority" field specifically
          if (student && student[fieldName] !== undefined) {
            return student[fieldName] 
              ? (language === "English" ? "Yes" : "आहे") 
              : (language === "English" ? "No" : "नाही");
          }
        }

        if (fieldName === 'isHosteller') {
          if (student && student[fieldName] !== undefined) {
            return (student[fieldName] === 'true')
              ? (language === "English" ? "Yes" : "आहे") 
              : (language === "English" ? "No" : "नाही");
          }
        }
        if (fieldName === 'isRTE') {
          if (student && student[fieldName] !== undefined) {
            return (student[fieldName] === 'true')
              ? (language === "English" ? "Yes" : "आहे") 
              : (language === "English" ? "No" : "नाही");
          }
        }
        if (fieldName === 'isScolar') {
          
          // Handle the "Is Minority" field specifically
          if (student && student[fieldName] !== undefined) {
            return (student[fieldName] === 'true')
              ? (language === "English" ? "Yes" : "आहे") 
              : (language === "English" ? "No" : "नाही");
          }
        }
        if (fieldName === 'isActive') {
          
          // Handle the "Is Minority" field specifically
          if (fieldName === 'isActive') {
            return student[fieldName] === true ? 'Active' : 'Deactive';
          }
        }
        return student && student[fieldName] !== undefined && student[fieldName] !== null
          ? student[fieldName]
          : ""; 
      });
    });
  
    XLSX.utils.sheet_add_aoa(ws, [customColumnNames], { origin: "A1" });
  
    XLSX.utils.sheet_add_aoa(ws, dataRows, { origin: "A2" });
  
    XLSX.utils.book_append_sheet(wb, ws, "Report Data");
    XLSX.writeFile(wb, "report_data.xlsx");
  };
  
  const [showTable, setShowTable] = useState(false); 

  const toggleTableVisibility = () => {
    setShowTable(!showTable); // Toggle the visibility state
  };

  return (
    <div>
    <div className="main-content-of-page ">
      {upshowing &&(
        <div className='loading-overlay'>
            <div  className="text-center">
              <img src={up} style={{width:'150px'}} alt="" /> 
            </div>
        </div>
      )}

    <style jsx>
                  {`
                    .loading-overlay {
                      position: fixed;
                      top: 0;
                      right: 0;
                      width: 88.5%;
                      height: 100%;
                      background: rgba(146, 146, 146, 0.1); /* Semi-transparent background */
                      backdrop-filter: blur(1px); /* Apply blur effect to the background */
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      z-index: 9999; /* Ensure it appears on top */
                    }

                    /* Style for the loading spinner or image */
                    .loading-overlay .text-center {
                      color: white;
                      font-size: 24px;
                      font-weight: bold;
                    }

                  `}
    </style>


      <h3 className='text-center mb-2' style={{ color:'#03365e', fontWeight:'600'}}>{language==="English"?"Import/Export Data":"डेटा आयात/निर्यात "}</h3>

      <div style={{boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)', border: '1px solid gray', padding: '20px', borderRadius: '5px', marginTop:'30px' }}>
      <div className="box" style={{ marginTop: "30px",marginBottom: "20px", display:'flex' }}>
        
        
        <div style={{display:'flex', width:'100%'}}>
          <label style={{width:'290px'}} >
            {language === "English" ? "To Upload Excel Sheet Choose File" : "एक्सेल शीट अपलोड करण्यासाठी फाइल निवडा"} : 
          </label>
          <input
          style={{height:'37px',width:'230px'}}
            id="file-input"
            type="file"
            onChange={handleFileUpload}
            accept=".xlsx, .xls"
          />
          </div>

          <div className="file-upload" style={{ textAlign: "center" }}>
  <button
    onClick={useTemplate}
    style={{ textAlign: "center", display: "block", margin: "0 auto", padding:'5px 7px', marginTop:'-10px', background:'brown', fontSize:'16px' }}
  >
    <FontAwesomeIcon icon={faDownload}  />{" "}
    {language === "English"
      ? "Download Template"
      : "टेम्पलेट डाउनलोड करा"}
  </button>
  <p style={{ marginTop: "10px", fontSize: "14px", color: "brown" }}>
    {language === "English"
      ? "Please download the template first, fill in the required fields, and then upload the completed file."
      : "कृपया टेम्पलेट डाउनलोड करा, आवश्यक फील्ड भरा आणि नंतर पूर्ण केलेली फाइल अपलोड करा."}
  </p>
</div>
       
      </div>
      {saveMessage && <p style={{fontWeight:'600', color:'green', marginTop:'-60px'}}>{saveMessage}</p>}
      {excelData.length>0 && (
        <div style={{display:'flex', gap:'20px'}}>
            <button
        onClick={toggleDataTableVisibility}
        style={{
          display: "block",
          backgroundColor:  "rgb(0, 123, 255)",
          color: "white",
          padding: "5px 7px",
          borderRadius: "5px",
          cursor: "pointer", fontSize:'16px'
        }}
      >
        {showDataTable
          ? language === "English"
            ? "Hide Table"
            : "टेबल लपवा"
          : language === "English"
          ?    <>
        <i className="fa-solid fa-eye"></i> View Data From Excel Sheet
      </> 
          : <>
        <i className="fa-solid fa-eye"></i> एक्सेल शीटमधील डेटा पहा
      </>  }
      </button>

              <button
                onClick={saveDataToFirebase}
                style={{

                  display: "block",
          padding: "5px 7px",
          cursor: "pointer",
                  backgroundColor: "green",
                  color: "white",
                  borderRadius: "5px",fontSize:'16px'
                }}
              >
                {language === "English" ? " Save Data In Database" : " डेटाबेसमध्ये डेटा सेव्ह करा "}
              </button>
</div>
          )}

      {showDataTable && (
        <div className="box" style={{ marginBottom: "50px", boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)', border: '1px solid gray', padding: '20px', borderRadius: '5px', marginTop:'40px' }}>
          <div
            style={{ overflow: "auto", maxHeight: "500px" }}
          >
            <h3>{language === "English" ? "Excel Data" : "एक्सेल डेटा"} </h3>
            <div className="table-responsive">
        <table className="table table-bordered" style={{ border: "1px solid black" }}>
          <thead className="thead-dark">
            <tr>
              {columns.map((column, columnIndex) => (
                <th key={columnIndex} style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {excelData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
           
          </div>
        </div>
      )}
<hr/>
      {databaseData.length > 0 && (
<>
        <div style={{ textAlign: 'center', marginBottom: '20px', marginTop:'30px' }}>
        <button
          onClick={toggleTableVisibility}
          style={{
            padding: '7px 10px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
        {showTable
  ? language === "English"
    ? "Hide Data"
    : "डेटा लपवा"
  : language === "English"
  ? (
      <>
        <i className="fa-solid fa-eye"></i> View Data From Database
      </>
    )
  : " डेटाबेसमधून डेटा पहा"}
        </button>
      </div>
      {showTable && databaseData.length > 0 && (
        <div className="box" style={{ marginBottom: "20px" }}>
      <div className="export-label-container" style={{ textAlign: "center", marginBottom: "10px", position: 'relative', zIndex: 2 }}>
        <h3 style={{ fontSize: "24px", backgroundColor: 'white', display: 'inline-block', padding: '0 10px' }}>
          {language === "English" ? "Data From Database" : "डेटाबेस मधील डेटा"}
        </h3>
      </div>
      <div style={{ overflowY: "auto", maxHeight: "600px", position: 'relative', boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)', border: '1px solid gray', padding: '25px', borderRadius: '5px' }}>
        <table style={{ border: "1px solid black", width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{  backgroundColor: 'white' }}>
            <tr>
              {customColumnNames.map((columnName, columnIndex) => (
                <th key={columnIndex} style={{ border: '1px solid black', padding: '8px', textAlign: 'left', backgroundColor: '#bcdcff', fontWeight:'600' }}>
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
  {databaseData.map((row, rowIndex) => (
    row && Object.values(row).some(value => value !== "") && (
      <tr key={rowIndex}>
        {customColumnNames.map((columnName, cellIndex) => {
          const fieldName = headingToFieldName[columnName];
          const cellValue = row[fieldName];

          return (
            <td key={cellIndex} style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>
              {fieldName === 'isActive'
                ? (cellValue === true ? 'Active' : 'Deactive')
                : (typeof cellValue === 'boolean' 
                  ? (cellValue ? 'Yes' : 'No') 
                  : (cellValue || " ")) 
              }
            </td>
          );
        })}
      </tr>
    )
  ))}
</tbody>

        </table>
      </div>
      <div className="export-button-container" style={{ textAlign: 'center', marginTop: '10px', marginBottom:'30px' }}>
        <button className="export-button" onClick={exportReportToExcel} style={{padding:'7px 10px'}}>
          <FontAwesomeIcon icon={faDownload} color="black" />
          {language === "English" ? " Export Data " : "डेटा निर्यात करा"}
        </button>
      </div>
    </div>
      )}
    </>
)}

</div>
</div>
    </div>
  );
}
export default Importexport; 